import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { QueryClient } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';

import { persistConfig } from './config';

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: (error: unknown) => {
        console.error('Mutation error:', error);
      },
      retry: false,
    },
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1000 * 60 * 60 * 1, // 1 hour
    },
  },
});

const persister = createAsyncStoragePersister({
  key: persistConfig.key,
  storage: window.localStorage,
});

persistQueryClient({
  maxAge: 1000 * 60 * 60 * 24, // 24 hours
  persister,
  queryClient,
});

export { persister, queryClient };
